import {BankAccountList, BankAccountRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Chip, TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const BankAccountListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<BankAccountList> = {
        title: "Cuentas bancarias",
        onClick: "/app/admin/accounting/bank-account",
        headers: [
            {title: "Nombre"},
            {title: "IBAN"},
            {title: "Banco"},
            {title: "Cuenta contable"},
            {title: "Activa"},
        ],
        decorator: (bean: BankAccountList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.name}
                </TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>{bean.iban}</TableCell>
                <TableCell>{bean.bankName}</TableCell>
                <TableCell sx={{fontFamily: "monospace"}}>
                    {bean.accountingAccount?.code}
                </TableCell>
                <TableCell>
                    <Chip
                        label={bean.active ? "Activa" : "Inactiva"}
                        color={bean.active ? "success" : "default"}
                        size="small"
                    />
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(BankAccountRestControllerApiFactory);
            return ctrl.pageBankAccount(currentPage, size, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
